<template>
  <div class="left-form-right-content">
    <div class="left-form-right-content__left">
      <component :is="componentName" v-bind="$attrs" v-on="$listeners"></component>
    </div>
    <div class="left-form-right-content__right">
      <div class="left-form-right-content__right-master">
        <div class="title" v-if="titleOne">{{ titleOne }}</div>
        <component :is="showTwoAttrs.componentName" v-bind="showTwoAttrs"></component>
      </div>
      <div class="left-form-right-content__right-export">
        <div class="title" v-if="titleTwo">{{ titleTwo }}</div>
        <i class="ivu-icon-icon-pg-dagou icon-setting" v-if="showIcon"></i>
        <component :is="showThreeAttrs.componentName" v-bind="showThreeAttrs"></component>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  componentName: String,
  titleOne: String,
  titleTwo: String,
  showIcon: { type: Boolean, default: false },
  twoAttrs: { type: Object, default: () => ({}) },
  threeAttrs: { type: Object, default: () => ({}) },
})

const showTwoAttrs = { componentName: 'PgReadText', ...props.twoAttrs }
const showThreeAttrs = { componentName: 'PgReadText', ...props.threeAttrs }
</script>
<style lang="scss">
@import '../style/left-form-right-content.scss';
</style>
